//
//
//
//

import axios from 'axios';
import wx from 'weixin-js-sdk';
import {promptMessage} from '@/api/dataHandling';
export default {
  methods: {
    getopenid (code) {
      axios.get('http://front.wh.jinxin-fertility.com/weixin/getOpenIdByCode?code=' + code).then(response => {
        if (response.data.resultCode == 'success') {
          if (response.data.openid.trim() != '') {
            this.openid = response.data.openid;
            console.log(this.$route.query,34)
            window.location.href = decodeURI(this.$route.query.jumpUrl) +'/fromopenid/' + this.openid;
          } else {
            this.$store.commit('updateLoadingStatus',{isLoading:false});
            promptMessage('提示', '未获取到登录人信息，请使用微信重试！')
          }
        } else {
          promptMessage('提示', '未获取到登录人信息，请关闭页面重新打开！')
        }
        this.$store.commit('updateLoadingStatus',{isLoading:false});
      }).catch(function (error) {
        promptMessage('提示' + error)

      });
    },
    getUrlParam (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      let url = 'http://front.wh.jinxin-fertility.com/';
      let search = url.split('?')[1]
      if (search) {
        var r = search.substr(0).match(reg)
        if (r !== null) return unescape(r[2])
        return null
      } else {
        return null
      }
    }
  },
  mounted(){
    var _this = this;
    this.$store.commit('updateLoadingStatus',{isLoading:true});
    axios.get('http://front.wh.jinxin-fertility.com/weixin/getsigninfo?url=' + encodeURIComponent(window.location.href)).then(response => {
      this.weixindata = response.data;
      const code = _this.getUrlParam('code');
        var appid = response.data.appId;
        var redirect_uri = encodeURIComponent(window.location.href);
        if(code == null || code === ''){
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_base&state=1#wechat_redirect"
        }else{
          _this.getopenid(code)
        }
    }).catch(function (error) {
      promptMessage('提示' +error)

    });
  }
}



// WEBPACK FOOTER //
// ./src/project/outsideProject/doctordetailTZ.vue